export const UploadIcon = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.4027 34.9118H26.7511C27.1979 34.9118 27.56 34.5498 27.56 34.1029V27.6533H29.3518C30.1424 27.6587 30.629 26.94 29.9232 26.2729L25.65 21.9986C25.2686 21.6828 24.8873 21.6828 24.507 21.9986L20.2327 26.2729C19.8084 26.9873 20.0135 27.4997 20.8042 27.6533H22.596V34.1029C22.596 34.5498 22.958 34.9118 23.4038 34.9118H23.4027ZM25.0763 23.7141L27.3988 26.0366H26.7511C26.3042 26.0366 25.9422 26.3986 25.9422 26.8455V33.2951H24.2105V26.8455C24.2105 26.3986 23.8485 26.0366 23.4016 26.0366H22.7539L25.0763 23.7141Z"
        fill="url(#paint0_linear_703_527)"
      />
      <path
        d="M43.9859 29.9092H37.2892C36.8423 29.9092 36.4803 30.2712 36.4803 30.7181V34.1405C36.4803 34.5874 36.8423 34.9494 37.2892 34.9494H43.9859C44.4328 34.9494 44.7948 34.5874 44.7948 34.1405V30.7181C44.7948 30.2712 44.4328 29.9092 43.9859 29.9092ZM43.177 33.3317H38.0981V31.5259H43.177V33.3317Z"
        fill="url(#paint1_linear_703_527)"
      />
      <path
        d="M43.9859 26.5986H37.2892C36.8423 26.5986 36.4803 26.9606 36.4803 27.4075C36.4803 27.8544 36.8423 28.2164 37.2892 28.2164H43.9859C44.4328 28.2164 44.7948 27.8544 44.7948 27.4075C44.7948 26.9606 44.4328 26.5986 43.9859 26.5986Z"
        fill="url(#paint2_linear_703_527)"
      />
      <path
        d="M52.0608 35.7123C51.3046 34.4029 49.5171 33.8346 48.1195 34.5715V22.0042C48.1195 21.5573 47.7575 21.1953 47.3106 21.1953C46.8637 21.1953 46.5017 21.5573 46.5017 22.0042V35.5018L38.7265 39.991H37.4439C36.9487 39.0457 35.9604 38.399 34.8217 38.399H29.8878C27.8962 37.5471 25.7391 36.7307 23.5488 36.7307C21.3585 36.7307 19.4829 37.0938 17.9876 37.5847V17.9511C22.437 16.9629 25.5651 12.6574 25.1333 8.12738H28.0831V16.256C28.197 16.9188 28.5794 17.1637 29.2282 16.9908L32.2425 15.6083L35.2568 16.9908C35.7455 17.2153 36.4019 16.8544 36.4019 16.256V8.12738H46.4985V18.4807C46.4985 18.9276 46.8605 19.2896 47.3074 19.2896C47.7543 19.2896 48.1163 18.9276 48.1163 18.4807V7.31956C48.1163 6.87269 47.7543 6.51067 47.3074 6.51067H24.8293C23.9334 3.31164 21.1866 0.71417 17.9306 0.0180742C17.4945 -0.0753831 17.0648 0.20284 16.9713 0.638975C16.8779 1.07511 17.1561 1.5048 17.5922 1.59826C21.0512 2.33839 23.5617 5.44827 23.5617 8.99213C23.5617 13.1612 20.1693 16.5536 15.9992 16.5536C11.829 16.5536 8.43771 13.1612 8.43771 8.99213C8.43771 5.44827 10.9482 2.33839 14.4072 1.59826C14.8433 1.5048 15.1215 1.07511 15.0281 0.638975C14.9346 0.20284 14.5038 -0.0753831 14.0688 0.0180742C9.92336 0.905382 6.82101 4.7511 6.82101 8.99213C6.82101 14.1011 11.2769 18.3658 16.373 18.1606V38.2185C15.6962 38.5311 15.1301 38.8534 14.6757 39.1477V37.4515C14.6757 37.0046 14.3137 36.6426 13.8668 36.6426H11.3123V35.7768C11.3123 35.3299 10.9503 34.9679 10.5034 34.9679H3.80889C3.36201 34.9679 3 35.3299 3 35.7768V54.1911C3 54.638 3.36201 55 3.80889 55H13.8679C14.3148 55 14.6768 54.638 14.6768 54.1911V51.6516H23.3146C23.7615 51.6516 24.1235 51.2896 24.1235 50.8428C24.1235 50.3959 23.7615 50.0339 23.3146 50.0339H14.6768V41.1479C15.5179 40.4529 18.4871 38.3453 23.5509 38.3453C25.7585 38.3453 29.514 39.9888 29.7385 40.0135H34.8228C36.3385 40.0135 36.8047 42.7012 34.8378 42.7012H25.0763C24.6295 42.7012 24.2675 43.0632 24.2675 43.5101C24.2675 43.957 24.6295 44.319 25.0763 44.319H34.8378C36.0366 44.319 37.0894 43.6143 37.5534 42.5358L48.8253 36.0271C50.341 35.1527 51.644 37.5031 50.1691 38.3549C50.1369 38.3743 36.4491 49.0692 36.4491 49.0692C35.6531 49.6923 34.6573 50.036 33.6443 50.036H26.8381C26.3912 50.036 26.0292 50.398 26.0292 50.8449C26.0292 51.2918 26.3912 51.6538 26.8381 51.6538H33.6443C35.0161 51.6538 36.3664 51.1887 37.4449 50.3443L51.0306 39.7256C52.425 38.6632 52.7687 37.3258 52.0597 35.7134L52.0608 35.7123ZM34.7884 14.9949L32.5819 13.983C32.3574 13.8852 32.1329 13.8852 31.9073 13.983L29.7009 14.9949V8.1263H34.7873V14.9949H34.7884ZM4.6167 36.5857H9.69563V53.3833H4.6167V36.5857ZM11.3123 53.3833V38.2593H13.059V53.3833H11.3123Z"
        fill="url(#paint3_linear_703_527)"
      />
      <path
        d="M12.4768 8.863C12.1868 8.52355 11.6776 8.48165 11.337 8.77169C10.9976 9.06173 10.9568 9.57091 11.2457 9.91144L13.7605 12.8645C13.9141 13.0449 14.1397 13.1491 14.376 13.1491C14.3803 13.1491 14.3857 13.1491 14.39 13.1491C14.6317 13.1449 14.8583 13.0331 15.0087 12.8441L19.9792 6.58887C20.2574 6.23975 20.1983 5.73057 19.8492 5.45342C19.5001 5.17519 18.9909 5.23428 18.7137 5.5834L14.3545 11.0684L12.4768 8.863Z"
        fill="url(#paint4_linear_703_527)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_703_527"
          x1="25.1405"
          y1="21.7617"
          x2="25.1405"
          y2="34.9118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF4F34" />
          <stop offset="1" stopColor="#411045" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_703_527"
          x1="40.6375"
          y1="29.9092"
          x2="40.6375"
          y2="34.9494"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF4F34" />
          <stop offset="1" stopColor="#411045" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_703_527"
          x1="40.6375"
          y1="26.5986"
          x2="40.6375"
          y2="28.2164"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF4F34" />
          <stop offset="1" stopColor="#411045" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_703_527"
          x1="27.709"
          y1="0"
          x2="27.709"
          y2="55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF4F34" />
          <stop offset="1" stopColor="#411045" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_703_527"
          x1="15.6039"
          y1="5.27783"
          x2="15.6039"
          y2="13.1491"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF4F34" />
          <stop offset="1" stopColor="#411045" />
        </linearGradient>
      </defs>
    </svg>
  );
};
